import React from 'react';

import { bemCssModules, getTestId } from '@utils';

import { Logo } from '@components/Logo';
import Modal from '@components/NewModal';

import CloseIcon from './icon_close.svg';

import styles from './IntroModal.scss';

const cn = bemCssModules(styles, 'IntroModal');
const ti = getTestId('IntroModal');

const blocks = [
  {
    head: 'Avoid Phishing:',
    texts: [
      'Never share private keys or recovery phrases.',
      'Double-check URLs to dodge fake sites.',
    ],
  },
  {
    head: 'Review Transactions:',
    texts: ['Confirm details carefully.', 'Recheck recipient addresses.'],
  },
  {
    head: 'Use Secure Wallets:',
    texts: ['Use the latest wallet software to stay safe from vulnerabilities.'],
  },
  {
    head: 'Spot Investment Scams:',
    texts: [
      'Avoid "guaranteed" returns or get-rich-quick schemes.',
      'Conduct research before any crypto investment.',
    ],
  },
  {
    head: 'Two-Factor Authentication (2FA):',
    texts: ['Enable 2FA for an extra layer of security.'],
  },
  {
    head: 'Stay Informed:',
    texts: ['Follow the latest crypto news.', 'Join forums for shared experiences.'],
  },
  {
    head: 'See Something Off?',
    texts: ['Report suspicious activities ASAP.'],
  },
];

export type IntroModalType = {
  isOpen: boolean;
  onClose(): void;
};

const IntroModal: CustomFC<IntroModalType> = ({ className, isOpen, onClose }) => {
  return (
    <Modal
      data-testid={ti()}
      className={cn(null, [className])}
      isOpen={isOpen}
      onClose={onClose}
      hideCloseButton
      hideMobileCloseButton
    >
      <div className={cn('container')}>
        <Logo className={cn('logo')} />

        <button type="button" className={cn('button')} onClick={onClose}>
          <CloseIcon />
        </button>
        <div className={cn('content')}>
          <h1 className={cn('title')}>Secure Your Transactions with Mercuryo</h1>
          <p className={cn('subtitle')}>
            Cryptocurrency's ever-changing landscape brings both opportunities and risks. Let's help
            you stay secure:
          </p>
          <div className={cn('blocks')}>
            {blocks.map((elem, index) => {
              return (
                <div key={elem.head} className={cn('block')}>
                  <div className={cn('head')}>
                    <span className={cn('index')}>{index + 1}.</span>
                    {elem.head}
                  </div>
                  <div className={cn('texts')}>
                    {elem.texts.map(text => {
                      return (
                        <div className={cn('text')} key={text}>
                          {`— ${text}`}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
          <p className={cn('footer')}>
            Your safety is paramount to us. Follow these steps to keep your assets safe. Need help
            or have queries? Our support team's ready to assist.
          </p>
          <p>Stay alert and secure in your crypto journey.</p>
          <p className={cn('regards')}>Warm regards,</p>
          <p>Mercuryo Team</p>
        </div>
      </div>
    </Modal>
  );
};

export default IntroModal;
